import React , { useState , useEffect } from 'react'


import  Row  from 'react-bootstrap/Row';
import  Col  from 'react-bootstrap/Col';

import Card from 'react-bootstrap/Card';


//import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
//import { faEnvelope , faPhone ,  faSearch , faClock , faTrash  } from '@fortawesome/free-solid-svg-icons'


import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPencil , faFileInvoice , faPhone , faPlus } from '@fortawesome/free-solid-svg-icons'
import AddFourth from './AddSecond/AddFourth';



function DoCaseCard01( {data , index , selected , naturaleza='D'}) {

  const [hover,setHover] = useState( false ) ;


  const [acValue,setAcValue] = useState( false )
  const [deValue,setDeValue] = useState( false )

  const [acState,setAcState] = useState( false )
  const [deState,setDeState] = useState( false )
  const [adState,setAdState] = useState( false )
  const [showFourth,setShowFourth] = useState( false ) ;


  function handleSecond()
  {
    setShowFourth( true ) ;
  }

  function handleExit()
  {
    setShowFourth( false ) ;
  }


  useEffect(() => {


    console.log( "Naturaleza = " + naturaleza )

    if ( naturaleza === "D" )
    {
      setAcValue( false ) ;
      setDeValue( true ) ;
      setAcState( false ) ;
      setDeState( true ) ;
      setAdState( false )

      return ;

    }


    if ( naturaleza === "A")
    {
      setAcValue( true ) ;
      setDeValue( false ) ;
      setAcState( true ) ;
      setDeState( false ) ;
      setAdState( false )
      return ;
    }

    if ( naturaleza === "AD")
    {

      setAcState( false ) ;
      setDeState( false ) ;
      setAdState( true ) ;

      // setAcValue( true ) ;
      // setDeValue( false ) ;
      // setAcState( true ) ;
      // setDeState( true ) ;
      return ;
    }


  } , [])



  return (
    <>
    <Card onClick={() => selected(index) } onMouseEnter={() => setHover(true) } onMouseLeave={()=> setHover(false)} >
      <Card.Header style={{padding:'1px'}}  >
        {/* <Nav variant="tabs" defaultActiveKey="#first">
          <Nav.Item>
            <Nav.Link href="#first">Active</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link href="#link">Link</Nav.Link>
          </Nav.Item>
        </Nav> */}
      </Card.Header>
      <Card.Body  style={{ backgroundColor: ( hover ? 'rgba(25, 165, 244, 0.15)' : 'white') }} >
        <Card.Title style={{fontFamily:'Satoshi-Bold' , fontSize :'16px' ,marginBottom : '2px'}}>{data.field3}</Card.Title>
        <Card.Text style={{fontFamily:'Satoshi-Bold' , fontSize :'11px', 
            color:'gray' , marginTop :'5x' , marginBottom : '2px'}}>
          {/* Marketing Director */}
          {data.field12}
        </Card.Text>

        {
              acState && (

                <Row style={{fontFamily:'Satoshi-Bold' , fontSize :'11px' , height :'18px'}}>

                <Col className='col-8'>
    
                  <p>Naturaleza </p>
    
                </Col>
    
                <Col  className='col-4'>
    
                  <p title='Acredora'>Acreedora</p>
                </Col>
    
              </Row>



              )


          }

          {
              deState && (

                
                <Row style={{fontFamily:'Satoshi-Bold' , fontSize :'11px' , height :'18px'}}>

                  <Col className='col-8'>
      
                    <p>Naturaleza </p>
      
                  </Col>
      
                  <Col  className='col-4'>
      
                    <p title='Deudora'>Deudora</p>
                  </Col>
    
                </Row>


              )
          }

          {



            adState && (

              <Row>

              <Col className='col-8'>
  
                <p>Naturaleza </p>
  
              </Col>
  
              <Col  className='col-4'>
  
                <p title='Acreedora/Deudora'>AD</p>
              </Col>
  
  
  
            </Row>
  

            )
          }

          <Row style={{fontFamily:'Satoshi-Bold' , fontSize :'11px' , height :'18px'}}>

            <Col className='col-8' >

              <p>Tipo</p>

            </Col>

            <Col  className='col-4'>

              <p title='Tipo'>{data.tipo}</p>
            </Col>



          </Row>



        {/* {
              acState && (

                <div className="form-check form-check-inline" style={{height:'12px'}} >
                  <input className="form-check-input" title='Acredora' type="radio" checked={acValue} disabled={acState} name={"radio"+index} id={"acreadora"}/>
                  <label className="form-check-label" htmlFor={"acreedora"}>
                    A
                  </label>
                </div>


              )


          }

          {
              deState && (
                  <div className="form-check form-check-inline" style={{height:'12px'}}>
                    <input className="form-check-input" title='Deudora' type="radio" checked={deValue} disabled={deState} name={"radio"+index} id={"deudora" } />
                    <label className="form-check-label" htmlFor={"deudora"}>
                      D
                    </label>
                  </div>
              )
          }

          {
            adState && (
              <div style={{textAlign:'center' , marginBottom : '5px'}}>
                <p style={{marginBottom : '5px'}}>AD</p>
              </div>
            )
          } */}




        <Row className='mb-0' style={{height:'18px'}}>
            <Col className='col-1'>
                <FontAwesomeIcon className='ps-0'  icon={faFileInvoice} 
                title='Mail' style={{color:'#7507FA'}} />
            </Col>

            <Col className='col-10' style={{fontFamily:'Satoshi-Bold' , fontSize :'11px'}}
             title='Mail'>
                <p>{data.field1}</p>
            </Col>

    

        </Row>

        <Row className='mt-2' style={{fontFamily:'Satoshi-Bold' , fontSize :'11px' , height :'18px'}}>        
            
            <Col className='col-1'>
                        
                <FontAwesomeIcon className='ps-0'  icon={faPencil} 
                title='Phone' style={{color:'#7507FA'}} />
            </Col>

            <Col className='col-9'>
                <p>{data.field4}</p>
            </Col>

            {
              data.tipo === "R" && (
                <Col className='col-1'>
                    <FontAwesomeIcon className='ps-0'  icon={faPlus} onClick={handleSecond}
                      title='Agregar' style={{color:'gray' , cursor:'grab' }} />
                </Col>

              )

            }

        </Row>

      </Card.Body>
    </Card>

    {
      showFourth && (
        <AddFourth code={data.field3} exitadd={handleExit} naturaleza={naturaleza}></AddFourth>
      )
    }

    </>
  )
}

    
export  default DoCaseCard01